export default __webpack_public_path__ + "static/media/access-hcp-color-logo.ca1560d3.png";